import {Component,ElementRef, NgZone, ViewChild, Inject, Optional, OnInit } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';
import { Router,ActivatedRoute } from '@angular/router';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector   : 'dialog-box-estructura-select',
    templateUrl: './dialog-box-estructuras.component.html',
    styleUrls  : ['./dialog-box-estructuras.component.scss']
})
export class SelectEstructurasUsuarioComponent
{
    LOCAL_DATA: Usuario = new Usuario({});
    displayedColumns: string[] = ['estructura','nombre', 'action'];

    constructor(public dialog: MatDialog,
                public userService: UsersService,
                private _snackBar: MatSnackBar,
                public dialogRef: MatDialogRef<SelectEstructurasUsuarioComponent>,
                public router: Router,
                public translate: TranslateService,
                private route: ActivatedRoute,
                private service: UsersService,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Usuario) {
                console.log(data);
                this.LOCAL_DATA = new Usuario(data);
                this.LOCAL_DATA.estructuras.sort((a, b) => (a.estructuraNombre > b.estructuraNombre) ? 1 : -1);
    }

    ngOnInit() {
      this.service.get(this.LOCAL_DATA.id).pipe().subscribe(req => {
        this.LOCAL_DATA = new Usuario(req.body);
        this.LOCAL_DATA.estructuras.sort((a, b) => (a.estructuraNombre > b.estructuraNombre) ? 1 : -1);
      });
      //this.LOCAL_DATA.estructuras.sort((a, b) => (a.estructuraNombre > b.estructuraNombre) ? 1 : -1);
    }

    openDialog(): void {
      var obj = {};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true  
      });

      dialogRef.afterClosed().subscribe(result => {

        if('data' in result && 'nodo' in result.data && !this.contieneNodo(result.data.nodo)){
          this.userService.addNodo(this.LOCAL_DATA.id,result.data.nodo).pipe(first()).subscribe(
            data => {
                this.LOCAL_DATA = data.body;
                //result.data.nodo.padre = result.data.estructura;
                //this.LOCAL_DATA.estructuras.push(result.data.nodo);
                this.LOCAL_DATA.estructuras.sort((a, b) => (a.estructuraNombre > b.estructuraNombre) ? 1 : -1);
                this.LOCAL_DATA.estructuras = [...this.LOCAL_DATA.estructuras];
                this.openSnackBar("Se asoció el usuario al nodo.","Cerrar");
          },
            error => {
              console.log(error);
              this.openSnackBar("No se pudo ingresar el usuario al nodo, ocurrió un error.","Cerrar");
            }
          );

        }

      });
    }

    contieneNodo(nodo):boolean{
      var contiene:boolean = false;
      this.LOCAL_DATA.estructuras.forEach(element => {
          if(element.id === nodo.id){
            contiene = true;
          }
      });

      return contiene;
    }

    delete(nodo):void{

      this.userService.removeNodo(this.LOCAL_DATA.id,nodo).pipe(first()).subscribe(
        data => {
            this.LOCAL_DATA = data.body;
            this.LOCAL_DATA.estructuras.sort((a, b) => (a.estructuraNombre > b.estructuraNombre) ? 1 : -1);
            this.LOCAL_DATA.estructuras = [...this.LOCAL_DATA.estructuras];
            this.openSnackBar("Se eliminó el usuario del nodo correctamente.","Cerrar");
      },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo eliminar el usuario del nodo, ocurrió un error.","Cerrar");
        }
      );

      /*
      this.LOCAL_DATA.estructuras = this.LOCAL_DATA.estructuras.filter((value, key) => {
        return value.id !== nodo.id;
      });
      */

    }

    closeDialog(): void
    {
      console.log('im here');
      this.dialogRef.close({event: 'Add', data: this.LOCAL_DATA});
    }


    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 5000,
      });
    }

}
